import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ActionModalHeader, { DemoNote, customerName } from "./ActionModalHeader";

// STATIC DESIGN — postpaid credit line settings (reads user_is_credit_line_enabled / user_wallet_balance)
interface CreditLineModalProps { show: boolean; onHide: () => void; user: any }

const CreditLineModal = ({ show, onHide, user }: CreditLineModalProps) => {
  const [enabled, setEnabled] = useState(false);
  const [limit, setLimit] = useState("10000");
  const [billing, setBilling] = useState("Invoice monthly (Net 15)");
  const [alertAt, setAlertAt] = useState("80% usage");

  useEffect(() => {
    if (show) {
      setEnabled(!!user?.user_is_credit_line_enabled);
      setLimit("10000");
      setBilling("Invoice monthly (Net 15)");
      setAlertAt("80% usage");
    }
  }, [show, user]);

  const save = () => {
    const lim = Number(limit.replace(/,/g, ""));
    if (enabled && (!lim || lim <= 0)) return toast.warning("Enter a credit limit greater than 0");
    toast.info(`${enabled ? `Credit line ₹${lim.toLocaleString("en-IN")} set` : "Credit line disabled"} · demo only, not saved`);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="cx">
      <ActionModalHeader icon="ri-bank-card-2-line" title="Credit line" subtitle={`${customerName(user)} · postpaid limit`} onClose={onHide} />
      <div style={{ padding: "14px 20px" }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14 }}>
          <label className="cx-switch">
            <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
            <span></span>
          </label>
          <span className="fs12">Credit line enabled — messages keep sending after the wallet hits ₹0, up to this limit</span>
        </div>
        <div style={{ opacity: enabled ? 1 : 0.4, pointerEvents: enabled ? "auto" : "none" }}>
          <div className="cx-fgrid">
            <div>
              <label className="cx-label">Credit limit (₹)</label>
              <input className="cx-input mono" inputMode="numeric" value={limit} onChange={(e) => setLimit(e.target.value)} />
            </div>
            <div>
              <label className="cx-label">Billing</label>
              <select className="cx-select" value={billing} onChange={(e) => setBilling(e.target.value)}>
                {["Invoice monthly (Net 15)", "Invoice monthly (Net 30)", "Auto-debit on renewal"].map(b => <option key={b}>{b}</option>)}
              </select>
            </div>
            {user?.user_is_credit_line_enabled && (
              <div className="full">
                <div className="cx-kv">
                  <div><small>Wallet balance</small><b className="mono">₹{Number(user.user_wallet_balance || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}</b></div>
                  <div><small>Status</small><b>Enabled</b></div>
                </div>
              </div>
            )}
            <div className="full">
              <label className="cx-label">Alert at</label>
              <select className="cx-select" value={alertAt} onChange={(e) => setAlertAt(e.target.value)}>
                {["80% usage", "90% usage", "100% usage"].map(a => <option key={a}>{a}</option>)}
              </select>
            </div>
          </div>
        </div>
        <DemoNote />
      </div>
      <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={save}>Save credit line</button>
      </div>
    </Modal>
  );
};

export default CreditLineModal;
